import { createAsyncThunk } from '@reduxjs/toolkit';

import { JsonQuery, type TJsonQuery } from '@/packages/JsonQuery';

import { type ILocation } from '@/microfrontends/filters/shared/types/location';
import { locationHasNeighbors } from '@/microfrontends/filters/shared/utils/locationHasNeighbors';
import { tempNormalizeLocation } from '@/microfrontends/filters/shared/utils/tempNormalizeLocation';

import { type TThunkApi } from '../../types';

import { updateMeta } from './updateMeta';

interface ISelectCityResult {
  city: ILocation;
  jsonQuery: TJsonQuery;
}

export const selectCity = createAsyncThunk<ISelectCityResult, ILocation, TThunkApi>(
  'locationPopup/selectCity',
  async (city, thunkApi) => {
    const { getState, dispatch } = thunkApi;

    const state = getState();

    const nextJsonQuery = new JsonQuery(state.locationPopup.jsonQuery);

    nextJsonQuery.setLocations({ next: [city], prev: tempNormalizeLocation(state.location.data) });

    // перенёс костыль для попапа смены региона, иначе мета запрашивается с тегом всегда
    if (!locationHasNeighbors(city)) {
      nextJsonQuery.setWithNeighbors(null);
    }

    const nextJsonQuerySerialized = nextJsonQuery.toJSON();

    // специально не блокируемся об получение мета
    dispatch(updateMeta(nextJsonQuerySerialized));

    return {
      city,
      jsonQuery: nextJsonQuerySerialized,
    };
  },
);
